import { observable, runInAction } from 'mobx'

const Domen = observable({
    url: process.env.REACT_APP_DOMAIN
})
export default Domen